import React from 'react'

import Input from './Input'

const NumberInput = ({ max, min, onlyInteger, ...props }) => {
  let replaceValue = undefined

  if (max !== undefined || min !== undefined || !!onlyInteger) {
    replaceValue = v => {
      if (max !== undefined && v > max) return max
      if (min !== undefined && v < min) return min
      if (v != '-' && v != '0' && v !== undefined && onlyInteger) return parseInt(v)
      return v
    }
  }

  return <Input type="number" replaceValue={replaceValue} {...props} />
}

export default NumberInput
